import React from 'react';
import CardManagement from '../components/CardManagement';


export default function CardManage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      <main>
        <CardManagement />
      </main>
      
    </div>
  );
}